/** Authenticated network boundary shared by the JSON API caller and replay's
 * binary/streaming transports. The caller owns credential renewal, identity
 * checks, cancellation, response consumption and retry policy.
 * For parsed JSON responses and the standard request policy, use makeSecureApiCall in ./api. */
export function makeSecureApiCall(url: string, request: RequestInit, getCredential: () => string,
    fetcher: typeof globalThis.fetch = globalThis.fetch.bind(globalThis)): Promise<Response> {
    const headers = new Headers(request.headers);
    headers.set('Authentication', 'Bearer ' + getCredential());
    return fetcher(url, {...request, headers});
}
